function initInteractiveLookbook(container = document) {
  const section =
    container.querySelector('#interactive-lookbook') ||
    document.querySelector('#interactive-lookbook');

  if (!section) return;

  const items = Array.from(section.querySelectorAll('.look-item'));
  if (!items.length) return;

  const scene = section.querySelector('#lookbook-scene');
  const viewBg = section.querySelector('#lookbook-view-bg');
  const viewBg2 = section.querySelector('#lookbook-view-bg-2');
  const stage = section.querySelector('.lookbook-stage');
  const productView = section.querySelector('#lookbook-product-view');
  let productMainGallery = section.querySelector('#lookbook-product-main-gallery');
  let bgClearTimer = null;
  let bgActiveLayer = 1;

  const detail = section.querySelector('#lookbook-detail');
  const detailTitle = section.querySelector('#lookbook-detail-title');
  const productThumb = section.querySelector('#lookbook-product-thumb');
  const productName = section.querySelector('#lookbook-product-name');
  const backBtn = section.querySelector('#lookbook-back-btn');
  const rail = section.querySelector('#lookbook-rail');
  const railItems = Array.from(section.querySelectorAll('.lookbook-rail-item'));
  const openProductBtn = section.querySelector('#lookbook-open-product');

  const productDetails = section.querySelector('#lookbook-product-details');
  const productThumbs = section.querySelector('#lookbook-product-thumbs');
  const footerThumb = section.querySelector('#lookbook-footer-thumb');
  const footerName = section.querySelector('#lookbook-product-footer-name');
  const footerPrice = section.querySelector('#lookbook-product-footer-price');
  const addCartBtn = section.querySelector('#lookbook-add-cart');
  const sizePopover = section.querySelector('#lookbook-size-popover');
  const sizeOptions = section.querySelector('#lookbook-size-options');

  const addCartStatus = section.querySelector('#lookbook-add-cart-status');
  const cartCountEl = section.querySelector('#lookbook-cart-count');

  const fullscreen = section.querySelector('#lookbook-fullscreen');
  const fullscreenImg = section.querySelector('#lookbook-fullscreen-img');

  const hotBtn = section.querySelector('#lookbook-menu-btn');
  const fireContainer = section.querySelector('.lookbook-fire-container');

  const scatterHint = section.querySelector('#lookbook-scatter-hint');

  const kicker = section.querySelector('#lookbook-kicker');
  const aboutBtn = section.querySelector('#lookbook-about-btn');
  const aboutModal = section.querySelector('#lookbook-about-modal');
  const aboutClose = section.querySelector('#lookbook-about-close');
  const aboutTitle = section.querySelector('#lookbook-about-title');
  const aboutRating = section.querySelector('#lookbook-about-rating');
  const aboutDescription = section.querySelector('#lookbook-about-description');
  const aboutReviews = section.querySelector('#lookbook-about-reviews');

  function setHint(text, opacity = '0.6') {
    if (!scatterHint) return;
    scatterHint.textContent = text;
    scatterHint.style.opacity = opacity;
  }

  function showScatterHint() {
    setHint('click on products to view', '0.6');
    if (stage) stage.classList.add('is-scatter-mode');
  }

  function showSwitchProductsHint() {
    setHint('swipe to switch products, click "view" to buy', '0.6');
  }

  function showProductInfoHint() {
    setHint('click about for details', '0.6');
  }

  let activeItem = null;
  let isProductMode = false;
  let hasSelectedOnce = false;

  function getGallery(raw) {
    try {
      const parsed = JSON.parse(raw || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function getVariants(raw) {
    try {
      const parsed = JSON.parse(raw || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function renderSizeOptions(item) {
    if (!sizeOptions) return;

    const variants = getVariants(item.dataset.variants);

    sizeOptions.innerHTML = '';

    variants.forEach((variant) => {
      const pill = document.createElement('button');

      pill.type = 'button';
      pill.className = 'lookbook-size-pill';
      pill.dataset.variantId = String(variant.id);
      pill.dataset.available = variant.available ? 'true' : 'false';
      pill.textContent = variant.title;

      if (!variant.available) {
        pill.disabled = true;
      }

      pill.addEventListener('click', async () => {
        if (!variant.available) return;
        if (!addCartBtn) return;

        addCartBtn.dataset.variantId = String(variant.id);
        addCartBtn.dataset.available = 'true';

        if (sizePopover) {
          sizePopover.classList.add('hidden');
        }

        await addToCart();
      });

      sizeOptions.appendChild(pill);
    });
  }

  function openAboutModal() {
    if (!activeItem || !aboutModal) return;

    if (aboutTitle) {
      aboutTitle.textContent = activeItem.dataset.title || '';
    }

    if (aboutRating) {
      aboutRating.innerHTML = `
        <div
          class="jdgm-widget jdgm-preview-badge"
          data-id="${activeItem.dataset.productId}"
          data-auto-install="false"
        >
          ${activeItem.dataset.judgemeBadge || ''}
        </div>
      `;
    }

    if (aboutDescription) {
      aboutDescription.innerHTML =
        activeItem.dataset.description || 'No description available.';
    }

    if (aboutReviews) {
      const hiddenWidget = activeItem.querySelector('.lookbook-hidden-judgeme-widget');

      if (hiddenWidget) {
        aboutReviews.innerHTML = hiddenWidget.innerHTML;
      } else {
        aboutReviews.innerHTML = '';
      }
    }

    aboutModal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      if (window.jdgm && typeof window.jdgm.refreshWidgets === 'function') {
        window.jdgm.refreshWidgets();
      }

      if (window.jdgm && typeof window.jdgm.renderWidgets === 'function') {
        window.jdgm.renderWidgets();
      }
    });
  }

  function closeAboutModal() {
    if (!aboutModal) return;

    aboutModal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  function applyBasePosition(item) {
    const x = parseFloat(item.dataset.x || '50');
    const y = parseFloat(item.dataset.y || '50');
    const scale = parseFloat(item.dataset.scale || '100') / 100;

    item.style.left = `${x}%`;
    item.style.top = `${y}%`;
    item.style.transform = `translate(-50%, -50%)`;
    item.style.setProperty('--item-scale', String(scale));
  }

  function markActiveRail(title, productUrl) {
    railItems.forEach((railItem) => {
      const isMatch =
        railItem.dataset.title === title &&
        railItem.dataset.productUrl === productUrl;

      railItem.classList.toggle('is-active', isMatch);
    });
  }

  function markActiveThumb(index) {
    const thumbButtons = Array.from(section.querySelectorAll('.lookbook-product-thumb-item'));

    thumbButtons.forEach((btn, i) => {
      btn.classList.toggle('is-active', i === index);
    });
  }

  function getActiveIndex() {
    return items.findIndex((item) => item === activeItem);
  }

  function selectByIndex(index) {
    if (!items.length) return;

    const wrappedIndex = (index + items.length) % items.length;
    const target = items[wrappedIndex];

    if (!target) return;

    requestAnimationFrame(() => {
      selectLookByData({
        title: target.dataset.title,
        productUrl: target.dataset.productUrl
      });
    });
  }

  function openFullscreen(src, alt = '') {
    if (!fullscreen || !fullscreenImg || !src) return;

    fullscreenImg.src = src;
    fullscreenImg.alt = alt;
    fullscreen.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeFullscreen() {
    if (!fullscreen || !fullscreenImg) return;

    fullscreen.classList.add('hidden');
    fullscreenImg.src = '';
    fullscreenImg.alt = '';
    document.body.style.overflow = '';
  }

  function bindProductMainGalleryEvents() {
    if (!productMainGallery) return;

    if (!productMainGallery.dataset.scrollBound) {
      productMainGallery.addEventListener(
        'scroll',
        () => {
          const width = productMainGallery.clientWidth || 1;
          const index = Math.round(productMainGallery.scrollLeft / width);
          markActiveThumb(index);
        },
        { passive: true }
      );

      productMainGallery.dataset.scrollBound = 'true';
    }

    if (!productMainGallery.dataset.fullscreenBound) {
      productMainGallery.addEventListener('click', (event) => {
        const clickedImage = event.target.closest('img');
        if (!clickedImage) return;
        openFullscreen(clickedImage.src, clickedImage.alt || '');
      });

      productMainGallery.dataset.fullscreenBound = 'true';
    }
  }

  function renderMainGallery(images) {
    if (!productMainGallery) return;

    const freshGallery = productMainGallery.cloneNode(false);
    freshGallery.id = productMainGallery.id;
    freshGallery.className = productMainGallery.className;
    freshGallery.removeAttribute('data-scroll-bound');
    freshGallery.removeAttribute('data-fullscreen-bound');

    images.forEach((url, index) => {
      const slide = document.createElement('div');
      slide.className = 'lookbook-product-main-slide';

      const img = document.createElement('img');
      img.src = url;
      img.alt = `Product image ${index + 1}`;
      img.loading = 'lazy';

      slide.appendChild(img);
      freshGallery.appendChild(slide);
    });

    productMainGallery.replaceWith(freshGallery);
    productMainGallery = section.querySelector('#lookbook-product-main-gallery');

    markActiveThumb(0);
    bindProductMainGalleryEvents();
  }

  function renderThumbs(images) {
    if (!productThumbs) return;

    productThumbs.innerHTML = '';

    images.forEach((url, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lookbook-product-thumb-item';
      btn.dataset.index = String(index);

      const img = document.createElement('img');
      img.src = url;
      img.alt = `Thumbnail ${index + 1}`;
      img.loading = 'lazy';

      btn.appendChild(img);

      btn.addEventListener('click', () => {
        const slideWidth = productMainGallery ? productMainGallery.clientWidth : 0;

        if (productMainGallery) {
          productMainGallery.scrollTo({
            left: slideWidth * index,
            behavior: 'smooth'
          });
        }

        markActiveThumb(index);
      });

      productThumbs.appendChild(btn);
    });

    markActiveThumb(0);
  }

  function updateProductFooter(item) {
    if (!item) return;

    if (footerThumb) footerThumb.src = item.dataset.thumb || '';
    if (footerName) footerName.textContent = item.dataset.title || '';

    if (footerPrice) {

      const price = item.dataset.price || '';
      const comparePrice = item.dataset.comparePrice || '';

      if (comparePrice) {

        footerPrice.innerHTML = `
          <span class="lookbook-compare-price">
            ${comparePrice}
          </span>

          <span class="lookbook-current-price">
            ${price}
          </span>
        `;

      } else {

        footerPrice.innerHTML = `
          <span class="lookbook-current-price">
            ${price}
          </span>
        `;
      }

      footerPrice.style.color =
        item.dataset.color || '#666';
    }

    if (addCartBtn) {
      const isAvailable = item.dataset.available === 'true';

      addCartBtn.dataset.available = item.dataset.available || 'false';
      addCartBtn.dataset.variantId = item.dataset.variantId || '';

      addCartBtn.style.color = item.dataset.color || '#999999';

      if (isAvailable) {
        addCartBtn.textContent = 'ADD TO CART';
        addCartBtn.disabled = false;
      } else {
        addCartBtn.textContent = 'COMING SOON';
        addCartBtn.disabled = true;
      }
    }

    if (sizePopover) {
      sizePopover.classList.add('hidden');
      sizePopover.style.color = item.dataset.color || '#999999';
    }

    renderSizeOptions(item);
  }

  function hideProductDetails() {
    if (productDetails) productDetails.classList.add('hidden');
    if (addCartStatus) addCartStatus.textContent = '';
    if (sizePopover) sizePopover.classList.add('hidden');
  }

  function showProductDetails() {
    if (!activeItem) return;

    const galleryImages = getGallery(activeItem.dataset.gallery);

    renderMainGallery(galleryImages);
    renderThumbs(galleryImages);
    updateProductFooter(activeItem);

    if (productDetails) productDetails.classList.remove('hidden');
    if (addCartStatus) addCartStatus.textContent = '';
  }

  function enterProductMode() {
    if (stage) stage.classList.remove('is-scatter-mode');
    if (!activeItem) return;

    isProductMode = true;

    if (productView) {
      productView.classList.add('hidden');
      productView.classList.add('is-entering');
    }

    if (productDetails) {
      productDetails.classList.add('is-entering');
    }

    if (detail) {
      detail.classList.add('is-transitioning-to-product');
    }

    setTimeout(() => {
      if (scene) scene.classList.add('is-collapsed');
      if (rail) rail.classList.add('hidden');
      if (detail) detail.classList.add('is-product-mode');

      if (kicker) kicker.classList.add('hidden');
      if (aboutBtn) aboutBtn.classList.remove('hidden');

      showProductDetails();
      showProductInfoHint();

      requestAnimationFrame(() => {
        if (productView) productView.classList.remove('hidden');
        if (detail) detail.classList.remove('is-transitioning-to-product');

        setTimeout(() => {
          if (productView) {
            productView.classList.remove('is-entering');
          }

          if (productDetails) {
            productDetails.classList.remove('is-entering');
          }
        }, 60);
      });
    }, 120);
  }

  function exitProductMode() {
    
    isProductMode = false;

    if (productView) productView.classList.add('hidden');
    if (detail) detail.classList.remove('is-product-mode');

    if (openProductBtn) {
      openProductBtn.classList.add('is-returning');
      
      requestAnimationFrame(() => {
        setTimeout(() => {
          openProductBtn.classList.remove('is-returning');
        }, 40);
      });
    }
    
    if (rail) rail.classList.remove('hidden');

    if (kicker) kicker.classList.remove('hidden');
    if (aboutBtn) aboutBtn.classList.add('hidden');

    closeAboutModal();

    hideProductDetails();

      setTimeout(() => {
        if (scene) scene.classList.remove('is-collapsed');
      }, 220);

    showSwitchProductsHint();
  }

  function selectLookByData(data) {
    const matchedItem = items.find((item) => {
      return (
        item.dataset.title === data.title &&
        item.dataset.productUrl === data.productUrl
      );
    });

    if (!matchedItem) return;

    activeItem = matchedItem;
    showViewBackground(activeItem);
    if (stage) stage.classList.remove('is-scatter-mode');
    isProductMode = false;

    items.forEach((other) => {
      other.classList.remove('is-selected', 'is-dimmed');

      if (other !== matchedItem) {
        other.classList.add('is-dimmed');
      }
    });

    matchedItem.classList.add('is-selected');

    if (detailTitle) detailTitle.textContent = matchedItem.dataset.title || '';
    if (productThumb) productThumb.src = matchedItem.dataset.thumb || '';
    if (productName) productName.textContent = matchedItem.dataset.title || '';

    if (detail) {
      detail.classList.remove('hidden');
      detail.classList.remove('is-product-mode');
    }

    if (!hasSelectedOnce && openProductBtn) {
      openProductBtn.classList.add('is-entering');

      requestAnimationFrame(() => {
        setTimeout(() => {
          openProductBtn.classList.remove('is-entering');
        }, 40);
      });

      hasSelectedOnce = true;
    }

    if (kicker) kicker.classList.remove('hidden');
    if (aboutBtn) aboutBtn.classList.add('hidden');
    closeAboutModal();

    if (scene) scene.classList.remove('is-collapsed');
    if (productView) productView.classList.add('hidden');
    if (rail) rail.classList.remove('hidden');

    hideProductDetails();
    showSwitchProductsHint();

    markActiveRail(
      matchedItem.dataset.title || '',
      matchedItem.dataset.productUrl || ''
    );

    const activeRail = railItems.find((railItem) => {
      return (
        railItem.dataset.title === matchedItem.dataset.title &&
        railItem.dataset.productUrl === matchedItem.dataset.productUrl
      );
    });

    if (activeRail) {
      activeRail.scrollIntoView({
        behavior: 'auto',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

  function showViewBackground(item) {
    if (!viewBg || !viewBg2) return;

    clearTimeout(bgClearTimer);

    if (!item || !item.dataset.viewBg) {
      hideViewBackground();
      return;
    }

    const nextImage = item.dataset.viewBg;
    const hasActiveBg =
      viewBg.classList.contains('is-active') ||
      viewBg2.classList.contains('is-active');

    const incomingBg = bgActiveLayer === 1 ? viewBg : viewBg2;
    const outgoingBg = bgActiveLayer === 1 ? viewBg2 : viewBg;

    const bgImage = new Image();

    bgImage.onload = () => {
      incomingBg.style.backgroundImage = `url("${nextImage}")`;

      requestAnimationFrame(() => {
        incomingBg.classList.add('is-active');

        if (hasActiveBg) {
          outgoingBg.classList.remove('is-active');
        }

        bgActiveLayer = bgActiveLayer === 1 ? 2 : 1;
      });
    };

    bgImage.src = nextImage;
  }

  function hideViewBackground() {
    if (!viewBg || !viewBg2) return;

    clearTimeout(bgClearTimer);

    viewBg.classList.remove('is-active');
    viewBg2.classList.remove('is-active');

    bgClearTimer = setTimeout(() => {
      viewBg.style.backgroundImage = '';
      viewBg2.style.backgroundImage = '';
    }, 900);
  }

  async function addToCart() {
    if (!addCartBtn) return;

    const variantId = addCartBtn.dataset.variantId;
    const isAvailable = addCartBtn.dataset.available === 'true';

    if (!variantId || !isAvailable) {
      addCartBtn.textContent = 'COMING SOON';
      addCartBtn.disabled = true;
      return;
    }

    const previousLabel = addCartBtn.textContent;
    const currentCount = cartCountEl ? parseInt(cartCountEl.textContent || '0', 10) || 0 : 0;

    addCartBtn.disabled = true;
    addCartBtn.textContent = 'ADDING...';

    if (addCartStatus) addCartStatus.textContent = '';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Unable to add this item right now.');
      }

      await response.json();

      if (cartCountEl) {
        cartCountEl.textContent = String(currentCount + 1);
      }

      if (window.VDivideCart3D){
        window.VDivideCart3D.update(currentCount + 1);
      }

      if (addCartStatus) {
        addCartStatus.textContent = '';
      }

      addCartBtn.textContent = 'ADDED';

      setTimeout(() => {
        addCartBtn.textContent = 'ADD TO CART';
        addCartBtn.disabled = false;
      }, 700);
    } catch (error) {
      if (cartCountEl) {
        cartCountEl.textContent = String(currentCount);
      }

      if (addCartStatus) {
        addCartStatus.textContent = error.message || 'Something went wrong.';
      }

      addCartBtn.textContent = previousLabel || 'ADD TO CART';
      addCartBtn.disabled = false;
    }
  }

  items.forEach((item) => {
    applyBasePosition(item);

    if (!item.dataset.clickBound) {
      item.addEventListener('click', () => {
        selectLookByData({
          title: item.dataset.title,
          productUrl: item.dataset.productUrl
        });
      });

      item.dataset.clickBound = 'true';
    }

    if (!item.dataset.swipeBound) {
      let startX = 0;
      let startY = 0;
      let isTouching = false;

      item.addEventListener(
        'touchstart',
        (event) => {
          if (!item.classList.contains('is-selected') || isProductMode) return;

          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          isTouching = true;
        },
        { passive: true }
      );

      item.addEventListener(
        'touchend',
        (event) => {
          if (!item.classList.contains('is-selected') || !isTouching || isProductMode) return;

          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - startX;
          const deltaY = touch.clientY - startY;

          isTouching = false;

          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

          const currentIndex = getActiveIndex();

          if (deltaX < 0) {
            selectByIndex(currentIndex + 1);
          } else {
            selectByIndex(currentIndex - 1);
          }
        },
        { passive: true }
      );

      let wheelLock = false;

      item.addEventListener(
        'wheel',
        (event) => {
          if (!item.classList.contains('is-selected') || isProductMode) return;
          if (Math.abs(event.deltaX) < 10 && Math.abs(event.deltaY) < 10) return;
          if (wheelLock) return;

          wheelLock = true;

          setTimeout(() => {
            wheelLock = false;
          }, 350);

          const currentIndex = getActiveIndex();
          const direction = Math.abs(event.deltaX) > Math.abs(event.deltaY)
            ? event.deltaX
            : event.deltaY;

          if (direction > 0) {
            selectByIndex(currentIndex + 1);
          } else {
            selectByIndex(currentIndex - 1);
          }
        },
        { passive: true }
      );

      item.dataset.swipeBound = 'true';
    }
  });

  setTimeout(() => {
    section.classList.add('is-ready');
  }, 1000);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      section.classList.add('is-ready');
    });
  });

  railItems.forEach((railItem) => {
    if (!railItem.dataset.clickBound) {
      railItem.addEventListener('click', () => {
        selectLookByData({
          title: railItem.dataset.title,
          productUrl: railItem.dataset.productUrl
        });
      });

      railItem.dataset.clickBound = 'true';
    }
  });

  if (productMainGallery && !productMainGallery.dataset.fullscreenBound) {
    productMainGallery.addEventListener('click', (event) => {
      const clickedImage = event.target.closest('img');

      if (!clickedImage) return;

      openFullscreen(clickedImage.src, clickedImage.alt || '');
    });

    productMainGallery.dataset.fullscreenBound = 'true';
  }

  if (fullscreen && !fullscreen.dataset.closeBound) {
    fullscreen.addEventListener('click', () => {
      closeFullscreen();
    });

    fullscreen.dataset.closeBound = 'true';
  }

  if (!section.dataset.escBound) {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAboutModal();
        closeFullscreen();
      }
    });

    section.dataset.escBound = 'true';
  }

  if (aboutBtn && !aboutBtn.dataset.clickBound) {
    aboutBtn.addEventListener('click', openAboutModal);
    aboutBtn.dataset.clickBound = 'true';
  }

  if (aboutClose && !aboutClose.dataset.clickBound) {
    aboutClose.addEventListener('click', closeAboutModal);
    aboutClose.dataset.clickBound = 'true';
  }

  if (aboutModal && !aboutModal.dataset.clickBound) {
    aboutModal.addEventListener('click', (event) => {
      if (event.target === aboutModal) {
        closeAboutModal();
      }
    });

    aboutModal.dataset.clickBound = 'true';
  }

  if (openProductBtn && !openProductBtn.dataset.clickBound) {
    openProductBtn.addEventListener('click', () => {
      enterProductMode();
    });

    openProductBtn.dataset.clickBound = 'true';
  }

  if (addCartBtn && !addCartBtn.dataset.clickBound) {
    addCartBtn.addEventListener('click', async () => {
      const variants = getVariants(activeItem?.dataset?.variants);
      const hasMultipleVariants = variants.length > 1;

      if (!hasMultipleVariants) {
        await addToCart();
        return;
      }

      if (sizePopover) {
        sizePopover.classList.toggle('hidden');
      }
    });

    addCartBtn.dataset.clickBound = 'true';
  }

  if (backBtn && !backBtn.dataset.clickBound) {
    backBtn.addEventListener('click', () => {
      if (!fullscreen.classList.contains('hidden')) {
        closeFullscreen();
        return;
      }

      if (aboutModal && !aboutModal.classList.contains('hidden')) {
        closeAboutModal();
        return;
      }

      if (isProductMode) {
        exitProductMode();
        return;
      }

      activeItem = null;
      hasSelectedOnce = false;

      hideViewBackground();

      items.forEach((item) => {
        item.classList.remove('is-selected', 'is-dimmed');
        applyBasePosition(item);
      });

      railItems.forEach((railItem) => railItem.classList.remove('is-active'));

      if (detail) {
        detail.classList.add('hidden');
        detail.classList.remove('is-product-mode');
      }

      if (kicker) kicker.classList.remove('hidden');
      if (aboutBtn) aboutBtn.classList.add('hidden');
      closeAboutModal();

      if (scene) scene.classList.remove('is-collapsed');
      if (productView) productView.classList.add('hidden');
      if (rail) rail.classList.remove('hidden');

      hideProductDetails();
      showScatterHint();
      isProductMode = false;
    });

    backBtn.dataset.clickBound = 'true';
  }

  if (hotBtn && !hotBtn.dataset.storyBound) {
    hotBtn.addEventListener('click', () => {
      window.location.href = '/pages/story';
    });

    hotBtn.dataset.storyBound = 'true';
  }
  showScatterHint();
}

document.addEventListener('DOMContentLoaded', () => {
  initInteractiveLookbook(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initInteractiveLookbook(event.target);
});

document.addEventListener('shopify:section:reorder', () => {
  initInteractiveLookbook(document);
});

document.addEventListener('shopify:section:select', (event) => {
  initInteractiveLookbook(event.target);
});

document.addEventListener('shopify:block:select', () => {
  initInteractiveLookbook(document);
});

document.addEventListener('shopify:block:deselect', () => {
  initInteractiveLookbook(document);
});